import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { DateUtils } from 'src/app/utils/date.utils';
import { GetDateObjectToFullIsoString } from '../../utils/get-data-object-to-full-ISO-string';
import { ProductSearchFilter } from './product-search-filter';

export class ProductSearchForm extends UntypedFormGroup {
  constructor() {
    super({
      productType: new UntypedFormControl(),
      tenor: new UntypedFormControl(),
      currency: new UntypedFormControl(),
      dateRange: new UntypedFormControl(),
      searchTerm: new UntypedFormControl(),
    });
  }

  toPayload(): ProductSearchFilter {
    let [from, to] = this.get('dateRange').value || [null, null];
    from =
      GetDateObjectToFullIsoString(DateUtils.convertDateToNgbDate(from));
    to = GetDateObjectToFullIsoString(DateUtils.convertDateToNgbDate(to));

    const { productType, tenor, currency, searchTerm } = this.value;

    const payload = new ProductSearchFilter(productType, tenor, currency, searchTerm, from, to);

    return payload.toFilterParams();
  }
}
